import { useQuery } from '@tanstack/react-query';
import http from '../../../utils/http';
import { ErrorResponse } from '../../types';
import { patientPrevAppointment } from './type/patient';

export function useGetAllPatientAppointments() {
  const { data, refetch, ...rest } = useQuery<patientPrevAppointment[], ErrorResponse>({
    queryKey: ['get all patient appointments'],
    queryFn: async () => {
      const response = await http.get("appointments/patient");
      return response.data?.appointments;
    },
    select: (data) => data?.filter((item) => !item?.didAppointmentHold) ?? [],
  });

  return {
    appointmentsList: data ?? [],
    refetch,
    ...rest,
  };
}






